export var Transform;
(function (Transform) {
    let Vector3;
    (function (Vector3) {
        function toVector2(a) {
            return { x: a[0], y: a[1] };
        }
        Vector3.toVector2 = toVector2;
        function position(a) {
            return [a.x, a.y, 1];
        }
        Vector3.position = position;
        function direction(a) {
            return [a.x, a.y, 0];
        }
        Vector3.direction = direction;
    })(Vector3 = Transform.Vector3 || (Transform.Vector3 = {}));
    function mul(a, b) {
        return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
    }
    function translation(offset) {
        return [
            [1, 0, offset.x],
            [0, 1, offset.y],
            [0, 0, 1]
        ];
    }
    Transform.translation = translation;
    function rotation(rot) {
        let theta = rot * Math.PI / 2;
        return [
            [Math.cos(theta), -Math.sin(theta), 0],
            [Math.sin(theta), Math.cos(theta), 0],
            [0, 0, 1]
        ];
    }
    Transform.rotation = rotation;
    function rotationRadians(radians) {
        let theta = radians;
        return [
            [Math.cos(theta), -Math.sin(theta), 0],
            [Math.sin(theta), Math.cos(theta), 0],
            [0, 0, 1]
        ];
    }
    Transform.rotationRadians = rotationRadians;
    function scale(scale) {
        return [
            [scale.x, 0, 0],
            [0, scale.y, 0],
            [0, 0, 1]
        ];
    }
    Transform.scale = scale;
    function mirror_x() {
        return [
            [-1, 0, 0],
            [0, 1, 0],
            [0, 0, 1]
        ];
    }
    Transform.mirror_x = mirror_x;
    function mirror_y() {
        return [
            [1, 0, 0],
            [0, -1, 0],
            [0, 0, 1]
        ];
    }
    Transform.mirror_y = mirror_y;
    function row(a, n) {
        return a[n];
    }
    Transform.row = row;
    function col(a, n) {
        return [a[0][n], a[1][n], a[2][n]];
    }
    Transform.col = col;
    function mult(a, b) {
        const indices = [0, 1, 2];
        return indices.map(r => indices.map(c => mul(row(a, r), col(b, c))));
    }
    Transform.mult = mult;
    function chain(...transforms) {
        let trans = identity();
        for (let transform of transforms) {
            trans = mult(trans, transform);
        }
        return trans;
    }
    Transform.chain = chain;
    function apply(a, b) {
        return [
            mul(row(a, 0), b),
            mul(row(a, 1), b),
            mul(row(a, 2), b),
        ];
    }
    Transform.apply = apply;
    function identity() {
        return [
            [1, 0, 0],
            [0, 1, 0],
            [0, 0, 1]
        ];
    }
    Transform.identity = identity;
})(Transform || (Transform = {}));
